import React, { FC, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './Page.module.scss';
import { PageContextProvider } from '../..';

interface PageProps {
	children: JSX.Element | JSX.Element[];
	title?: string;
}

const Page: FC<PageProps> = ({ children, title }): JSX.Element => {
	const page = useRef<HTMLElement>(null);

	const onScroll = () => {
		page.current?.scrollTo(0, 0);
	};

	return (
		<section className={styles.Page} ref={page}>
			{title && <h4 className={styles.Title}>{title}</h4>}
			<PageContextProvider scroll={onScroll}>{children}</PageContextProvider>
		</section>
	);
};

Page.propTypes = {
	title: PropTypes.string,
};

export { Page };
